module.exports = __webpack_public_path__ + "static/img/tfi.a829dda0.png";